import Tracker from '@framework/analytics-tracker/Tracker';
import { inject, injectable } from 'inversify';
import Request from '@framework/api/Rpc/Request';
import formatISO from 'date-fns/formatISO';
import { type ISocketDispatcher } from '@evercall/socket-client';
import EvercallSocketDITypes from '@evercall/socket-client/DITypes';
import getUTCDate from '@framework/date-helpers/getUTCDate';
import { IAnalyticsPayload } from '@/evercall/application/AnalyticsTracker/interfaces';

@injectable()
class EvercallTracker extends Tracker {
  constructor(
    @inject(EvercallSocketDITypes.SocketDispatcher) private socketRpc: ISocketDispatcher,
  ) {
    super();
  }

  track = async ({
    eventName,
    payload,
  }: {
    eventName: string,
    payload: IAnalyticsPayload,
  }): Promise<void> => {
    await this.socketRpc.call(
      new Request('evercall.track_event', {
        subjectKey: eventName,
        subjectBody: payload,
        occurredAt: formatISO(getUTCDate()),
      }),
    );
  };
}

export default EvercallTracker;
